export default function Footer() {
  return (
    <footer className="bg-dark text-white py-4 mt-5">
      <div className="container text-center">
        
        {/* Developed By */}
        <div className="d-flex justify-content-center align-items-center">
          <span className="me-2">Developed by</span>
          <img 
            src="image.png" 
            alt="RACE Logo" 
            style={{ height: "30px" }} 
          />
          <strong className="ms-2">RACE</strong>
        </div>

        <p className="mt-3 mb-0">© {new Date().getFullYear()} LegendImpex. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
